<template>
  <LazyLoader
    api-key="homeBanner"
    wrap-class="ad"
    skeleton-height="89"
    @init="fetch"
    @show="reportShow"
  >
    <img
      v-if="banner.img_url"
      :src="banner.img_url"
      @click="
        $util.bannerJump(banner)
        reportClick()
      "
    />
  </LazyLoader>
</template>

<script>
export default {
  data() {
    return {
      banner: {}
    }
  },
  methods: {
    fetch() {
      this.$request('homeBanner').then(
        (data) => (this.banner = (data || [])[0] || {})
      )
    },
    reportClick() {
      this.$xlaPush('home_page_banner_content_click', this.getExtData())
    },
    getExtData() {
      const isGame =
        Global.CONS.CollectionType.game === this.banner.collection_type
      return {
        area: 'bottom',
        rn: 0,
        game_id: isGame ? this.banner.game_id : 'other',
        game_name: isGame ? this.banner.title : 'other',
        url: this.banner.jump_url
      }
    },
    reportShow() {
      this.$xlaPush('home_page_banner_content_show', this.getExtData())
    }
  }
}
</script>
